import { render } from "./FavouritesPage.vue?vue&type=template&id=24d5864c&scoped=true"
import script from "./FavouritesPage.vue?vue&type=script&lang=js"
export * from "./FavouritesPage.vue?vue&type=script&lang=js"

import "./FavouritesPage.vue?vue&type=style&index=0&id=24d5864c&lang=scss&scoped=true"

import exportComponent from "/srv/swensa.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d5864c"]])

export default __exports__